define([
	"dojo/_base/declare",
	"csi",
	"csi/_base/underscore",
	"csi/xml",
	"SiteAdmin/AttributeMap/AttributeMapTable"
], function(declare,csi,_,xml,AttributeMapTable) {

	var SETTINGS_URL = "centric://REFLECTION/INSTANCE/SupplierItemConfig/Settings";
	var SETUP_SETTINGS_URL = "centric://REFLECTION/INSTANCE/SupplierItemConfig/SetupSettings";
	var MAP_SETTING_ID = "StyleAttributeMap";
	var MAP_ENTRY_NODE_TYPE = "_StyleAttributeMapEntry_";
	var DEST_ATTR_ID_ATTR = "StyleAttributeId";
	var ATTRIBUTE_OWNER = "AttributeOwner";

	var MODIFIED_ATTR = "Modified";
	var APPLIED_ON_ATTR = "AppliedOn";

	AttributeMapTable.watchValueDropDown(MAP_ENTRY_NODE_TYPE, DEST_ATTR_ID_ATTR);

	return declare(AttributeMapTable, {
		settingsUrl: SETTINGS_URL,
		setupSettingsUrl: SETUP_SETTINGS_URL,
		mapSettingId: MAP_SETTING_ID,
		mapEntryNodeType: MAP_ENTRY_NODE_TYPE,
		destAttrIdAttr: DEST_ATTR_ID_ATTR,
		attributeOwner: ATTRIBUTE_OWNER,
		sourceClassName: "SupplierItem",
		additionalSourceClassNames: ["SupplierItemRevision"],

		_createRowNodes: function() {
			// summary: create a fake node for each table row
			var map = this._getMapSetting();
			var setUpMap = this._getMapSetupSetting();
			var appliedOn = this._getSetupSettings()[this.APPLIED_ON_ATTR];

			// sort source attributes
			var sortedAttributes = csi.sort(this._getSourceAttributes(), (function (node) {
			    return node.m_rcOwner.m_type + " " + node.getId().toUpperCase();
			}));

			return _.map(sortedAttributes, function(sourceAttr) {
				var node = xml.nodeCreateClientNode(null, this.mapEntryNodeType, sourceAttr.getId());
				var destAttrId = map[sourceAttr.getId()] || "";
				var setUpDestAttrId = setUpMap[sourceAttr.getId()] || "";
				xml.nodeCreateClientAttr(node, this.destAttrIdAttr, xml.ATTR_STRING, setUpDestAttrId);
				xml.nodeCreateClientAttr(node, this.attributeOwner, xml.ATTR_STRING, sourceAttr.m_rcOwner.m_type);
				// make the row yellow if the setup mapping is different from the published mapping
				xml.nodeCreateClientAttr(node, MODIFIED_ATTR, xml.ATTR_BOOLEAN, setUpDestAttrId != destAttrId);
				// make the row white if it is not mapped
				xml.nodeCreateClientAttr(node, APPLIED_ON_ATTR, xml.ATTR_TIME, setUpDestAttrId ? appliedOn : 0);
				xml.nodeCreateClientAttr(node, "_type", xml.ATTR_STRING, this._getTypeForMatching(sourceAttr));
				return node;
			}, this);
		}
	});
});
